import * as sharedAuthState from '../../store/shared-auth-state';

import { Injectable, inject } from '@angular/core';
import { SharedGenericService } from './shared-generic.service';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { SharedStorageKeyEnum } from '../_config/storage/shared-storage-key-enum';
import { captureException } from '@sentry/angular';
import { sharedAuthCallActions } from 'src/app/store/shared-auth-call';
import { SpxStorage, SpxStorageKeyEnum } from '@softpak/components/spx-storage';
import { spxChannelReducer } from '@softpak/components/spx-channel-selection';

interface SharedSignInResponseI {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

@Injectable({
  providedIn: 'root'
})
export class SharedAuthService {
  private appStore = inject(Store);
  private sharedGenericService = inject(SharedGenericService);

  public loggedIn;
  public sessionCreated;

  login(auth?: { login: string; password: string }, ignoreTokenInStorage = false): Promise<any> {
    return new Promise<void>((_resolve, _reject) => {
      this.appStore.select(spxChannelReducer.default.selectChannel).pipe(take(1)).subscribe(channel => {
        if (channel) {
          if (!ignoreTokenInStorage && SpxStorage.getChannelSetting<SharedStorageKeyEnum>(SpxStorageKeyEnum.token)) {
            this.signedIn(true);
          } else if (auth) {
            this.appStore.dispatch(sharedAuthCallActions.load({}));
            this.sharedGenericService.signIn(`${auth.login.replace('@', '<at>')}|${channel.backendCompanyCode}`, auth.password)
              .subscribe({
                next: (signInResponse: SharedSignInResponseI) => {
                  this.appStore.dispatch(sharedAuthCallActions.received({}));
                  this.appStore.dispatch(sharedAuthState.sharedAuthStateActions.signingIn({}));
                  SpxStorage.setChannelSetting<SharedStorageKeyEnum>(SpxStorageKeyEnum.token, signInResponse?.access_token);
                  if (signInResponse.expires_in < 36000 && channel.backendCompanyCode !== "ROW") {
                    captureException(`[SHARED / Auth Service] Token Expiry is too short at ${channel.backendCompanyCode}!`, { level: 'fatal' });
                  }
                  this.signedIn(auth ? true : false);
                },
                error: _error => {
                  this.appStore.dispatch(sharedAuthCallActions.error({}));
                  this.appStore.dispatch(sharedAuthState.sharedAuthStateActions.reset({}));
                }
              });
            }
          }
      });
    });
  }

  public tryAutomaticSignIn() {
    this.login().then(() => {
    });
  }

  private signedIn(showWelcomeBack: boolean): void {
    this.loggedIn = true;
    this.appStore.dispatch(sharedAuthState.sharedAuthStateActions.signedIn({ username: 'user' }));
  }
}
